import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { TableComponentProps } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLables = {
  filing_type: {
    name: 'Filing type',
    order: 4
  },
  aifm_content_type: {
    name: 'AIFM content type',
    order: 5
  },
  reporting_period_start_date: {
    name: 'Reporting period start date',
    order: 6
  },
  reporting_period_end_date: {
    name: 'Reporting period end date',
    order: 7
  },
  reporting_period_type: {
    name: 'Reporting period type',
    order: 8
  },
  reporting_period_year: {
    name: 'Reporting period year',
    order: 9
  },
  aifm_reporting_obligation_change_frequency_code: {
    name: 'Change in AIFM reporting obligation frequency Code',
    order: 10
  },
  aifm_reporting_obligation_change_contents_code: {
    name: 'Change in AIFM reporting obligation contents Code',
    order: 11
  },

  aifm_reporting_obligation_change_quarter: {
    name: 'Change in AIFM reporting obligation Quarter',
    order: 12
  },

  last_reporting_flag: {
    name: 'Last reporting flag',
    order: 13
  }
};

export const FundIdentificationCodesAIF001 = ({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) => {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.MAIN_INFO,
    onChangeFund,
    schema: schema.MAIN_INFO,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MAIN_INFO?.field_names || [],
    tableName: 'MAIN_INFO',
    columnLables,
    funds,
    isMultiFunds
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.MAIN_INFO?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.MAIN_INFO?.find(item => item?.errors?.general)
    ?.errors?.general;

  return (
    <>
      <Errors id="reporttables-fund-identification-codes-aif001-errors">
        {isRequiredTable && (
          <li id="reporttables-fund-identification-codes-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li
            key={item.msg}
            id={`reporttables-fund-identification-codes-aif001-error-${idCreator(item.msg)}`}
          >
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="reporttables-fund-identification-codes-aif001-table"
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        handleChanges={onChange}
        columns={columns}
        rows={rows}
      />
    </>
  );
};
